import { GameTileProps } from '@/components/modular-grid/types';

import { parseJackpotGameProvider } from './parseJackpotGameProvider';

type GameType = Pick<GameTileProps, 'jackpotCode' | 'provider'>;

export const groupJackpotGamesByAllowedProviders = (
  games: GameType[],
  allowedProviders: string[] = []
) => {
  const parsedAllowedProviders = allowedProviders.map(provider =>
    parseJackpotGameProvider(provider)
  );
  const allowedGames = games.filter(
    game =>
      game.jackpotCode &&
      game.provider &&
      parsedAllowedProviders.includes(parseJackpotGameProvider(game.provider))
  );
  return allowedGames.reduce((games: Record<string, GameType[]>, game) => {
    if (!game.provider) {
      return games;
    }
    const providerGamesGroup = games[game.provider] || [];
    providerGamesGroup.push(game);
    games[game.provider] = providerGamesGroup;
    return games;
  }, {});
};
